import React, { useState, useEffect } from 'react';
import { connect } from "react-redux";
import withSizes from 'react-sizes';
import Prismic from '@prismicio/client';

import { Col } from "deltoid/core/Blocks/BootstrapContainers";

import PayUIcon from "../../../assets/svgs/PayU-Icon.svg";
import LoginIllustration from "../../../assets/svgs/loginIllustration.svg";

import { fetchResellerData } from '../../../shared/actions/auth';

import config from '../../../shared/services/config';

const OAuthCMS = (props) => {
  const apiEndPoint = config.get('prismicCmsHost');
  const accessToken = config.get('cmsAccessToken');
  const Client = Prismic.client(apiEndPoint, { accessToken })

  const [doc, setDocData] = useState(null);
  const [resellerId, setResllerId] = useState(null);
  const [resellerData, setResellerData] = useState(null);


  const fetchData = async () => {
    let UIDs = [config.get('PRISMIC_DEFAULT_OAUTH_DOC_ID')];
    if (config.get('campaign_context'))
      UIDs = [config.get('campaign_context'), ...UIDs]
    const response = await Client.query(Prismic.Predicates.in('my.login.uid', UIDs))
    if (response) {
      setDocData(response.results[0].data)
    }
  }
  useEffect(() => {
    fetchData()
    const queryString = window.sessionStorage.getItem('queryString');
    const urlParams = new URLSearchParams(queryString);
    const reseller_id = urlParams.get('reseller_id');
    setResllerId(reseller_id);
    async function fetchReseller() {
      let response = await fetchResellerData(props.dispatch)
      setResellerData(response.data);
    }
    reseller_id && fetchReseller()
  }, []);

  const onLogoClick = () => {
    window.open(`${process.env.PAYU_WEBSITE_HOST}`, "_blank");
  }

  const getLogo = () => {
    return (
      <div className='p-4'>
        {resellerId && resellerData ?
          <div className='hosted-partner-container'>
            {resellerData && <img src={resellerData.logo} />}
            {resellerData && <span className='pl-2'>{resellerData.name}</span>}
          </div>
          :
          <PayUIcon className='w-auto' onClick={onLogoClick} />
        }
      </div>
    )
  }

  return (
    <>
      {props.isMobile ?
        (
          <Col md={12} className='p-0 d-flex justify-content-between grey-background login-illustration'>
            {getLogo()}
            <LoginIllustration />
          </Col>
        )
        :
        (
            <div className='cms-content pl-5'>
              {
                doc && (
                  <div className='pl-5 pt-4'>
                    {getLogo()}
                    <h4 className='pt-5 px-5 font-weight-bold co-heading mt-5'>
                      Empower your {resellerData.name} <br/>
                      payments with <PayUIcon />
                    </h4>
                    <div className='pt-3 px-5'>
                      {doc.description.map((el, index) =>
                        <li key={index} className='d-flex pb-3'>
                          <img src={el.bullet.url} width={el.bullet.dimensions.width} height={el.bullet.dimensions.height} className='w-auto' />
                          <p className='pl-2 co-heading key-points'>{el.data[0].text}</p>
                        </li>
                      )}
                    </div>
                  </div>
                )
              }
            </div>
        )
      }
    </>
  )

}

const mapSizesToProps = ({ width }) => ({
  isMobile: width < 768,
});


const mapDispatchToProps = (dispatch) => ({
  dispatch,
});

const Responsive = withSizes(mapSizesToProps)(OAuthCMS);

export default connect(null, mapDispatchToProps)(Responsive);